<template>
  <div v-if="element" :class="`${element.compData.type}-theme-${element.compData.styleId}`"
       :style="{...getStyles(element.compData.styles),
       width: element.width + 'px',
       height: element.height + 'px'}">
    <div class="date">
      <div class="content">{{ date | formatDate(element.compData.format) }}</div>
    </div>
  </div>
</template>

<script>
// iview
import {
  Input
} from 'view-design'
import 'view-design/dist/styles/iview.css'

export default {
  name: 'compDate',
  props: {
    element: {
      type: Object,
      default: null,
      require: true
    }
  },
  filters: {
    formatDate: function (value, format) {
      const date = new Date(value)
      const handleFill = function (i) { return (i < 10 ? '0' : '') + i }
      const time = format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (val) {
        switch (val) {
          case 'yyyy':
            return handleFill(date.getFullYear())
          case 'MM':
            return handleFill(date.getMonth() + 1)
          case 'dd':
            return handleFill(date.getDate())
          case 'HH':
            return handleFill(date.getHours())
          case 'mm':
            return handleFill(date.getMinutes())
          case 'ss':
            return handleFill(date.getSeconds())
          default:
            return 'xx'
        }
      })
      return time
    }
  },
  data () {
    return {
      date: new Date().getTime(),
      dateInterval: null
    }
  },
  computed: {
    plugin: function() {
      return this.$getPlugin(this.element.id)
    }
  },
  methods: {
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$blueMap.trigger({
      nodeType: 'plugin',
      pluginId: this.element.id,
      dataKey: 'onmounted',
      eventData: {
        value: null,
        data: this.plugin,
        event: null
        }
      })
    })
    this.dateInterval = setInterval(() => {
      this.date = new Date().getTime()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.dateInterval)
  },
  components: {
    Input
  },
  created(){
    console.log('日期预览')
  }
}
</script>

<style lang='less' scoped>
  .date {
    width: 100%;
    height: 100%;
  }
  .content {
    font-size: var(--fontSize);
    color: var(--fontColor);
    font-family: var(--fontFamily) !important;
  }
</style>
